module.exports = __webpack_public_path__ + "media/src/images/zu_12question_snap03-a9b80a8d39bf297585db3bd2b2795a64.png";